var _g, _path, _path2, _path3, _path4, _path5, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStFullLogoDarkTheme(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10323",
    "data-name": "Group 10323",
    xmlns: "http://www.w3.org/2000/svg",
    width: 197.311,
    height: 30,
    viewBox: "0 0 197.311 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1141",
    "data-name": "Group 1141"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1345",
    "data-name": "Path 1345",
    d: "M173.729,158.384a6.584,6.584,0,0,1-4.6,1.466h-4.9v-2.62h5.242a2.869,2.869,0,0,0,2.069-.759,2.438,2.438,0,0,0,.793-1.827v-3.587a2.526,2.526,0,0,0-.534-1.673,1.978,1.978,0,0,0-1.6-.638H169.16a5.417,5.417,0,0,1-4.035-1.5,5.952,5.952,0,0,1-1.483-4.363v-1.31a5.666,5.666,0,0,1,1.6-4.4,6.589,6.589,0,0,1,4.6-1.466h4.931v2.62h-5.276a2.87,2.87,0,0,0-2.069.759,2.44,2.44,0,0,0-.793,1.827v2.621a2.436,2.436,0,0,0,.69,1.776,2.393,2.393,0,0,0,1.793.707h1.035a5.042,5.042,0,0,1,3.81,1.413,5.955,5.955,0,0,1,1.362,4.276v2.276A5.665,5.665,0,0,1,173.729,158.384Z",
    transform: "translate(-163.643 -135.712)",
    fill: "#f93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1346",
    "data-name": "Path 1346",
    d: "M190.044,160.35h-1.173a5.793,5.793,0,0,1-4.155-1.31,5.625,5.625,0,0,1-1.362-4.207V143.108h2.931v12.414a2.083,2.083,0,0,0,2.241,2.241h1.862a2.187,2.187,0,0,0,1.637-.551,2.05,2.05,0,0,0,.6-1.242V143.108h2.931V160.35H192.8v-.793A4.705,4.705,0,0,1,190.044,160.35Z",
    transform: "translate(-164.975 -136.212)",
    fill: "#f93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1347",
    "data-name": "Path 1347",
    d: "M205.862,143.108v.828a4.376,4.376,0,0,1,2.759-.828h1.241a6.453,6.453,0,0,1,4.448,1.293,5.492,5.492,0,0,1,1.414,4.225v6.207a5.46,5.46,0,0,1-1.431,4.207,6.4,6.4,0,0,1-4.431,1.31h-3.828v5.862H203.1v-23.1Zm.724,3.19a1.889,1.889,0,0,0-.552,1.294v10.172h4.173a2.813,2.813,0,0,0,1.931-.586,2.107,2.107,0,0,0,.655-1.656v-7.586a2.108,2.108,0,0,0-.655-1.655,2.813,2.813,0,0,0-1.931-.587h-1.932A2.178,2.178,0,0,0,206.587,146.3Z",
    transform: "translate(-166.31 -136.212)",
    fill: "#f93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1348",
    "data-name": "Path 1348",
    d: "M224.747,159.057a5.484,5.484,0,0,1-1.414-4.224v-6.207q0-2.965,1.276-4.241t4.241-1.276h1.621a4.806,4.806,0,0,1,3.707,1.362,5.672,5.672,0,0,1,1.259,3.983v4.483h-9.172v2.586a2.107,2.107,0,0,0,.655,1.656,2.812,2.812,0,0,0,1.931.586h5.484v2.586H229.2A6.441,6.441,0,0,1,224.747,159.057Zm7.827-11.293a2.006,2.006,0,0,0-2.069-2.069h-2a2.226,2.226,0,0,0-1.741.57,2.46,2.46,0,0,0-.5,1.672v2.414h6.31Z",
    transform: "translate(-167.678 -136.212)",
    fill: "#f93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1349",
    "data-name": "Path 1349",
    d: "M246.043,157.764V145.695h-2.518v-2.586H248.8v.931a4.212,4.212,0,0,1,2.759-.931h3.552v2.759h-3.9a1.971,1.971,0,0,0-1.655.707,2.523,2.523,0,0,0-.586,1.431v9.759h3.759v2.586h-9.207v-2.586Z",
    transform: "translate(-169.043 -136.212)",
    fill: "#f93"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1350",
    "data-name": "Path 1350",
    d: "M267.759,159.85V138.332h-5.483v-2.62h13.966v2.62h-5.483V159.85Z",
    transform: "translate(-170.31 -135.712)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1352",
    "data-name": "Path 1352",
    d: "M306.222,152.471v7.379H303.29V135.712h2.931v13.034l5.413-6.138h3.69l-6,6.793,6.483,10.448h-3.621l-5.069-8.414Z",
    transform: "translate(-173.083 -135.712)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1353",
    "data-name": "Path 1353",
    d: "M324.6,159.057a5.484,5.484,0,0,1-1.414-4.224v-6.207q0-2.965,1.276-4.241t4.241-1.276h1.621a4.8,4.8,0,0,1,3.706,1.362,5.668,5.668,0,0,1,1.26,3.983v4.483h-9.173v2.586a2.107,2.107,0,0,0,.655,1.656,2.814,2.814,0,0,0,1.932.586h5.483v2.586h-5.138A6.444,6.444,0,0,1,324.6,159.057Zm7.827-11.293a2.006,2.006,0,0,0-2.069-2.069h-2a2.229,2.229,0,0,0-1.741.57,2.465,2.465,0,0,0-.5,1.672v2.414h6.311Z",
    transform: "translate(-174.428 -136.212)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1354",
    "data-name": "Path 1354",
    d: "M345.656,143.108v.828a4.378,4.378,0,0,1,2.759-.828H350a5.8,5.8,0,0,1,4.156,1.311,5.629,5.629,0,0,1,1.361,4.207V160.35h-2.931V147.936a2.081,2.081,0,0,0-2.241-2.242H348.07a2.178,2.178,0,0,0-1.689.6,1.889,1.889,0,0,0-.552,1.294V160.35H342.9V143.108Z",
    transform: "translate(-175.76 -136.212)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1355",
    "data-name": "Path 1355",
    d: "M373.17,159.281a6.007,6.007,0,0,1-3.844,1.069h-5.138v-2.586h5.483a2.181,2.181,0,0,0,1.414-.4,1.407,1.407,0,0,0,.482-1.155v-1.828q0-1.552-1.483-1.552h-1.276a5.313,5.313,0,0,1-3.6-1.052,4.224,4.224,0,0,1-1.189-3.328v-1a3.951,3.951,0,0,1,1.31-3.328,6.216,6.216,0,0,1,3.862-1.018h4.621v2.586h-4.966a2.205,2.205,0,0,0-1.379.4,1.365,1.365,0,0,0-.517,1.154v1.242a1.422,1.422,0,0,0,.465,1.172,1.819,1.819,0,0,0,1.191.38h1.171a4.993,4.993,0,0,1,3.518,1.121,4.326,4.326,0,0,1,1.207,3.328v1.552A3.916,3.916,0,0,1,373.17,159.281Z",
    transform: "translate(-177.187 -136.212)",
    fill: "#fff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1805",
    "data-name": "Group 1805",
    transform: "translate(104.759 6.895)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_1",
    "data-name": "Exclusion 1",
    d: "M9.208,18.287c-.05,0-.1,0-.151,0a3.651,3.651,0,0,1-1.815-.662c-.152-.1-.3-.212-.451-.319l-.013-.009a8.123,8.123,0,0,0-.972-.636,3.634,3.634,0,0,0-1.681-.419H4.044a2.9,2.9,0,0,0-.662.067.969.969,0,0,0-.448.852,1.589,1.589,0,0,0,.146.584,1.516,1.516,0,0,1,.135.351h0c-.017,0-.061-.053-.143-.155A4.512,4.512,0,0,0,.7,16.228a.87.87,0,0,1-.552-1.344C3.064,10.6,3.428,9.068,4.783,3.373L4.9,2.881q.129-.544.272-1.138a.877.877,0,0,1,.513-.6L7.328.454A.87.87,0,0,1,7.662.388.891.891,0,0,1,7.8.4,7.082,7.082,0,0,1,10.379,0h1.137A7.081,7.081,0,0,1,14.1.4a.875.875,0,0,0-.5.266l-4.946.375h0L8.3.664A.877.877,0,0,0,7.8.4a2.915,2.915,0,0,0-.9.543,4.194,4.194,0,0,0-.975,3.168V10.3A4.2,4.2,0,0,0,6.9,13.473a5.138,5.138,0,0,0,3.478.94h1.137a5.138,5.138,0,0,0,3.478-.94A4.2,4.2,0,0,0,15.97,10.3V4.109A4.2,4.2,0,0,0,14.995.942,2.923,2.923,0,0,0,14.1.4a.9.9,0,0,1,.135-.01.865.865,0,0,1,.334.067l1.643.684a.877.877,0,0,1,.512.6c.3,1.264.56,2.392.747,3.215,1.041,4.569,1.43,6.278,4.057,10.143a.87.87,0,0,1-.551,1.344,3.992,3.992,0,0,0-2.231,1.576c-.053.069-.077.1-.083.1a1.1,1.1,0,0,1,.1-.242l.059-.135a1.6,1.6,0,0,0,.145-.584.941.941,0,0,0-.325-.754,5.023,5.023,0,0,0-1.1-.138l-.117,0a1.734,1.734,0,0,0-1.428.579,2.473,2.473,0,0,0-.148.225l-.006.011a2.149,2.149,0,0,1-.181.269.657.657,0,0,1-.536.263,2.211,2.211,0,0,1-.909-.309c-.12-.06-.218-.11-.312-.15a2.855,2.855,0,0,0-1.106-.258,1.828,1.828,0,0,0-.318.027,3.8,3.8,0,0,0-1.37.661c-.1.063-.191.125-.286.185A2.971,2.971,0,0,1,9.208,18.287Z",
    transform: "translate(0 1.395)",
    fill: "#f93",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4056",
    "data-name": "Group 4056",
    transform: "translate(2.925 10.973)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14227",
    "data-name": "Path 14227",
    d: "M698.042,464.7l.08-1.349,1.217-.352.5,1.573A2.345,2.345,0,0,0,698.042,464.7Z",
    transform: "translate(-689.199 -457.121)",
    fill: "#db902e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14229",
    "data-name": "Path 14229",
    d: "M659.165,442.151c0,.032,0,.5,0,.542-.975-.173-1.771.147-1.746.875h-.008v-.208c-.04-1.407.654-2.586,1.044-3.888.32-1.076.466-4.349.725-3.268a7.15,7.15,0,0,1-.018,2.776,11.494,11.494,0,0,0,0,1.582Z",
    transform: "translate(-657.412 -435.988)",
    fill: "#db902e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14231",
    "data-name": "Path 14231",
    d: "M722.562,442.151c0,.032,0,.5,0,.542.853.045,1.771.147,1.746.875h.008v-.208c.04-1.407-.654-2.586-1.044-3.888-.32-1.076-.466-4.349-.725-3.268a7.141,7.141,0,0,0,.019,2.776,11.513,11.513,0,0,1,0,1.582Z",
    transform: "translate(-708.266 -435.988)",
    fill: "#db902e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1803",
    "data-name": "Group 1803",
    transform: "translate(4.53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14233",
    "data-name": "Path 14233",
    d: "M671.773,388.364a3.792,3.792,0,0,1,2.536.574,3.175,3.175,0,0,1,.522,2.14v6.194a3.172,3.172,0,0,1-.523,2.14,3.789,3.789,0,0,1-2.535.574h-1.136a3.787,3.787,0,0,1-2.536-.575,3.174,3.174,0,0,1-.522-2.139v-6.194a3.175,3.175,0,0,1,.522-2.14,3.793,3.793,0,0,1,2.536-.574h1.136m0-2.791h-1.136a6.385,6.385,0,0,0-4.421,1.307,5.447,5.447,0,0,0-1.428,4.2v6.194a5.447,5.447,0,0,0,1.428,4.2,6.383,6.383,0,0,0,4.421,1.307h1.136a6.382,6.382,0,0,0,4.421-1.307,5.447,5.447,0,0,0,1.428-4.2v-6.194a5.448,5.448,0,0,0-1.428-4.2,6.384,6.384,0,0,0-4.421-1.307Z",
    transform: "translate(-664.788 -385.573)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1804",
    "data-name": "Group 1804",
    transform: "translate(9.738 7.584)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_669",
    "data-name": "Ellipse 669",
    cx: 1.209,
    cy: 1.209,
    rx: 1.209,
    ry: 1.209,
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14234",
    "data-name": "Path 14234",
    d: "M691.889,429.988h-1.13a.255.255,0,0,1-.254-.28l.232-2.391a.255.255,0,0,1,.254-.231h.665a.255.255,0,0,1,.254.231l.232,2.391A.255.255,0,0,1,691.889,429.988Z",
    transform: "translate(-690.115 -425.635)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStFullLogoDarkTheme);
export default __webpack_public_path__ + "static/media/ST_full_logo_dark_theme.svg";
export { ForwardRef as ReactComponent };